import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import ChatWidget from "./ChatWidget";

function getBgStyle(cfg) {
  if (!cfg || cfg.type === "default") return {};
  const opacity = cfg.opacity ?? 0.08;

  if (cfg.type === "custom_img" && cfg.imgData) {
    return {
      backgroundImage: `url(${cfg.imgData})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundAttachment: "fixed",
      opacity: undefined,
      // wrap handled below
    };
  }
  if (cfg.type === "pattern_dot") {
    return {
      backgroundImage: `radial-gradient(circle, rgba(45,74,34,${opacity * 3}) 1px, transparent 0)`,
      backgroundSize: "20px 20px",
    };
  }
  if (cfg.type === "pattern_grid") {
    return {
      backgroundImage: `linear-gradient(rgba(45,74,34,${opacity * 2}) 1px, transparent 1px), linear-gradient(90deg, rgba(45,74,34,${opacity * 2}) 1px, transparent 1px)`,
      backgroundSize: "24px 24px",
    };
  }
  if (cfg.type === "pattern_wave") {
    return {
      backgroundImage: `linear-gradient(135deg, rgba(244,241,234,${opacity * 8}) 25%, rgba(232,245,233,${opacity * 8}) 50%, rgba(244,241,234,${opacity * 8}) 75%)`,
      backgroundSize: "60px 60px",
    };
  }
  if (cfg.value && cfg.value.startsWith("linear-gradient")) {
    return { backgroundImage: cfg.value };
  }
  return {};
}

export default function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [bgCfg, setBgCfg] = useState(() => {
    try { return JSON.parse(localStorage.getItem("app_bg") || "null") || { type: "default" }; }
    catch { return { type: "default" }; }
  });

  useEffect(() => {
    const handler = (e) => setBgCfg(e.detail);
    window.addEventListener("app_bg_change", handler);
    return () => window.removeEventListener("app_bg_change", handler);
  }, []);

  const isCustomImg = bgCfg.type === "custom_img" && bgCfg.imgData;
  const bgStyle = getBgStyle(bgCfg);

  return (
    <div className="min-h-screen bg-paper relative">
      {/* Lớp nền mờ phía sau */}
      {bgCfg.type !== "default" && (
        isCustomImg ? (
          <div
            className="fixed inset-0 pointer-events-none z-0"
            style={{
              backgroundImage: `url(${bgCfg.imgData})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundAttachment: "fixed",
              opacity: bgCfg.opacity ?? 0.08,
            }}
          />
        ) : (
          <div
            className="fixed inset-0 pointer-events-none z-0"
            style={bgStyle}
          />
        )
      )}

      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="md:ml-64 relative z-10">
        <Header onMenu={() => setMobileOpen(true)} />
        <main className="p-4 md:p-8 max-w-[1400px] mx-auto" data-testid="main-content">
          <Outlet />
        </main>
      </div>
      <ChatWidget />
    </div>
  );
}